import { type AxiosError } from 'axios';
import { Logger } from 'src/utils/logger';
import { apiMetricsPublisher, METRIC } from 'src/utils/metrics';

export const API_REQUEST_ERROR = 'API Request Error';
export const API_RESPONSE_ERROR = 'API Response Error';

export const logAxiosError = (error: AxiosError) => {
  const { config, response } = error;
  let errorMessage = API_REQUEST_ERROR;
  const context: Record<string, unknown> = {
    request: {
      baseURL: config?.baseURL,
      route: config?.url,
      method: config?.method,
      params: JSON.stringify(config?.params),
      body: JSON.stringify(config?.data),
    },
  };

  if (response) {
    errorMessage = API_RESPONSE_ERROR;
    context.response = {
      data: JSON.stringify(response.data as Record<string, unknown>),
      status: response.status,
      statusText: response.statusText,
    };
  }

  Logger.error(errorMessage, error, context);
  apiMetricsPublisher.publishCounter(METRIC.Error, 1);
};
